export type UsageCategoryName = "Compute" | "Connections" | "Storage" | "API";

export type LimitBannerBodyInput = {
	hasResettingExceedance: boolean;
	hasNonResettingExceedance: boolean;
	resetDateLabel: string;
};

export function formatCategoryList(items: readonly string[]): string {
	if (items.length === 0) return "";
	if (items.length === 1) return items[0];
	if (items.length === 2) return `${items[0]} and ${items[1]}`;
	return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
}

export function buildLimitBannerTitle(categories: readonly UsageCategoryName[]): string {
	if (categories.length === 0) return "";
	if (categories.length === 4) return "You've hit all of your plan's limits!";
	const noun = categories.length === 1 ? "limit" : "limits";
	return `You've hit the ${formatCategoryList(categories)} ${noun} of your plan!`;
}

export function buildLimitBannerBody(input: LimitBannerBodyInput): string {
	const { hasResettingExceedance: reset, hasNonResettingExceedance: persist, resetDateLabel } = input;
	const datePhrase = resetDateLabel ? ` on ${resetDateLabel}` : "";

	if (reset && persist) {
		return resetDateLabel
			? `You can keep using your existing resources. Some limits will reset${datePhrase} — others can only be lifted by upgrading.`
			: "You can keep using your existing resources. Some limits will reset on their next cycle — others can only be lifted by upgrading.";
	}
	if (reset) {
		return resetDateLabel
			? `You can keep using your existing resources. Limits reset${datePhrase}, or upgrade for more headroom now.`
			: "You can keep using your existing resources until your limits reset, or upgrade for more headroom now.";
	}
	return "You can keep using your existing resources, but to add more you'll need to upgrade.";
}
